import { snap } from '@m/alchemy-ui';
import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  height: ${snap(100)};
`;
